export default class GetConjuntoEvaluacionesUsecase {
  constructor(repository) {
    this.repository = repository
  }

  async execute(idPersonal) {
    const response = await this.repository.fetchConjuntoEvaluaciones(idPersonal)
    return response
  }
}
